import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import {
  HomeRounded,
  ArrowBackRounded,
  SearchOffRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        width: "100%",
        height: "100dvh",
        overflow: "auto",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        p: { xs: 2, md: 3 },
        background: "#edf2f7",
      }}
    >
      
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          borderRadius: { xs: 2, md: 3 },
          border: "1px solid #dce5ef",
          background: "#fff",
          boxShadow: "0 8px 30px rgba(20, 40, 80, 0.06)",
        }}
      >
        
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            flexShrink: 0,
            px: { xs: 3, md: 6 },
            py: { xs: 3, md: 4 },
            color: "#fff",
            background:
              "linear-gradient(115deg, #111a33 0%, #294ba5 55%, #279e9b 100%)",
          }}
        >
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 800,
              letterSpacing: 2,
              color: "#c4ddff",
              mb: 1,
            }}
          >
            TRACKCOREDATA
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: 25, md: 34 },
              fontWeight: 800,
              letterSpacing: "-0.5px",
            }}
          >
            Page Not Found
          </Typography>

          <Typography
            sx={{
              mt: 1,
              color: "#e0eaff",
              fontSize: { xs: 13, md: 15 },
            }}
          >
            The requested page could not be found.
          </Typography>

          <Box
            sx={{
              position: "absolute",
              width: 230,
              height: 230,
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,0.12)",
              right: -70,
              top: -130,
              pointerEvents: "none",
            }}
          />
        </Box>

        
        <Box
          sx={{
            flex: 1,
            minHeight: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 3, sm: 5, md: 9 },
            py: { xs: 5, md: 6 },
            background:
              "radial-gradient(circle at 80% 50%, #edf5ff 0%, #ffffff 45%, #f8fafc 100%)",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 1050,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: { xs: 4, md: 8 },
              flexDirection: { xs: "column-reverse", md: "row" },
            }}
          >
            
            <Box
              sx={{
                flex: "1 1 500px",
                width: { xs: "100%", md: "auto" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: 88, sm: 110, md: 140 },
                  lineHeight: 0.95,
                  fontWeight: 900,
                  letterSpacing: { xs: -4, md: -8 },
                  color: "#17274c",
                }}
              >
                404
              </Typography>

              <Typography
                sx={{
                  mt: 3,
                  fontSize: { xs: 23, md: 32 },
                  fontWeight: 800,
                  color: "#17274c",
                }}
              >
                Oops! Page not found
              </Typography>

              <Typography
                sx={{
                  mt: 2,
                  maxWidth: 470,
                  mx: { xs: "auto", md: 0 },
                  color: "#64748b",
                  fontSize: { xs: 14, md: 16 },
                  lineHeight: 1.9,
                }}
              >
                The page you're looking for may have been moved,
                deleted, or the URL may be incorrect.
                Let's get you back on track.
              </Typography>

              <Box
                sx={{
                  mt: 4,
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: { xs: "center", md: "flex-start" },
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<HomeRounded />}
                  onClick={() => navigate("/overview")}
                  sx={{
                    px: 3,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 700,
                    background:
                      "linear-gradient(100deg, #2546a0 0%, #168f99 100%)",
                    boxShadow: "0 6px 16px rgba(37,70,160,0.2)",
                    "&:hover": {
                      background:
                        "linear-gradient(100deg, #1a347c 0%, #117a82 100%)",
                      boxShadow: "0 8px 20px rgba(37,70,160,0.25)",
                    },
                  }}
                >
                  Go to Dashboard
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<ArrowBackRounded />}
                  onClick={() => navigate(-1)}
                  sx={{
                    px: 3,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 700,
                    color: "#2546a0",
                    borderColor: "#cbd5e1",
                    backgroundColor: "#fff",
                    "&:hover": {
                      borderColor: "#2546a0",
                      backgroundColor: "#f1f5f9",
                    },
                  }}
                >
                  Go Back
                </Button>
              </Box>
            </Box>

            
            <Box
              sx={{
                flex: "0 1 360px",
                width: { xs: 200, sm: 250, md: 330 },
                height: { xs: 200, sm: 250, md: 330 },
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, #dceaff 0%, #edf4ff 55%, rgba(237,244,255,0) 72%)",
              }}
            >
              <Box
                sx={{
                  width: { xs: 125, md: 185 },
                  height: { xs: 145, md: 215 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 4,
                  backgroundColor: "#fff",
                  border: "1px solid #dce7f7",
                  boxShadow: "0 18px 45px rgba(37,70,160,0.12)",
                  transform: "rotate(-7deg)",
                }}
              >
                <SearchOffRounded
                  sx={{
                    fontSize: { xs: 65, md: 95 },
                    color: "#3478f6",
                  }}
                />

                <Typography
                  sx={{
                    mt: 1,
                    fontWeight: 800,
                    fontSize: { xs: 20, md: 28 },
                    color: "#17274c",
                  }}
                >
                  404
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        
        <Box
          sx={{
            flexShrink: 0,
            px: { xs: 3, md: 5 },
            py: 2,
            borderTop: "1px solid #e8edf4",
            backgroundColor: "#f8fafc",
          }}
        >
          <Typography sx={{ fontSize: 12, color: "#64748b" }}>
            TrackCoreData · Application Navigation
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default NotFound;
